<template>
  <div class="f-header">
    <span class="logo">
      <el-icon :size="30" class="mr-2">
        <Van />
      </el-icon>
      林肯BM系统
    </span>
    <el-icon class="icon-btn" @click="store.handleAsideWidth">
      <fold v-if="store.asideWidth == '250px'" />
      <Expand v-else />
    </el-icon>
<!--    <el-tooltip effect="dark" content="刷新" placement="bottom">-->
<!--      <el-icon class="icon-btn" @click="handleRefresh">-->
<!--        <refresh />-->
<!--      </el-icon>-->
<!--    </el-tooltip>-->

    <div class="ml-auto flex items-center">
<!--      <el-badge :value="noticeCnt" :hidden="noticeCnt < 1" class="badge">-->
<!--        <el-icon class="icon-msg" :size="30" @click="openNotice">-->
<!--          <Message />-->
<!--        </el-icon>-->
<!--      </el-badge>-->
      <el-dropdown class="dropdown" @command="handleCommand">
        <span class="flex items-center text-light-50">
          {{ store.user.userName }} -
          {{ store.user.realName }}
          <el-icon class="el-icon--right">
            <arrow-down />
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="updatePwd">修改密码</el-dropdown-item>
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>

  <form-dialog ref="formDialogRef" :title="title" @submit="onSubmit" :is-qiang="isQiang">
    <el-form class="m-auto  w-1/2" ref="formRef" :rules="rules" :model="form" label-width="80px">
      <el-form-item prop="oldPassword" label="旧密码">
        <el-input type="password" v-model="form.oldPassword" placeholder="请输入旧密码" show-password></el-input>
      </el-form-item>
      <el-form-item prop="password" label="新密码">
        <el-input type="password" v-model="form.password" placeholder="请输入密码" show-password></el-input>
      </el-form-item>
      <el-form-item prop="repassword" label="确认密码">
        <el-input type="password" v-model="form.repassword" placeholder="请输入确认密码" show-password></el-input>
      </el-form-item>
    </el-form>
  </form-dialog>
</template>

<script setup>

import FormDialog from '~/components/FormDialog.vue'
import { Funds } from '@icon-park/vue-next'
import { router } from '~/router'
import { useStore } from '~/store'
import { storeToRefs } from 'pinia'
import { useRepassWord, useLogout } from '~/utils/useManager'
import { onMounted, ref } from 'vue'

const store = useStore()
const { noticeCnt } = storeToRefs(store)
const isQiang = ref(false)
const title = ref('修改密码')

const {
  formDialogRef,
  form,
  rules,
  formRef,
  onSubmit,
  openRePasswordForm
} = useRepassWord()

const {
  handleLogout
} = useLogout()

onMounted(() => {
  console.log(store.user);
  if(store.user.isDealer == 1 && store.user.isChangePassword == 0){
    isQiang.value = true
    title.value = '首次登录，请修改密码'
    openRePasswordForm()
  }
})
const handleCommand = (c) => {
  switch (c) {
    case 'updatePwd':
      openRePasswordForm()
      break
    case 'download':
      clientDownload()
      break
    case 'logout':
      handleLogout()
      break
  }
}

const handleRefresh = () => location.reload()

function clientDownload() {
  const a = document.createElement('a')
  a.href = import.meta.env.VITE_APP_BASE_URL + '/install.zip'
  a.download = '经销商汽车销售发票上传客户端安装程序.zip'
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  a.remove()
}

function openNotice() {
  // router.push('/noticInfoManage')
  router.push('/dealerBasicInformation')
}

</script>

<style scoped>
.f-header {
  @apply flex items-center bg-gray-500 text-light-50 fixed top-0 left-0 right-0;
  height: 60px;
}

.logo {
  width: 250px;
  @apply flex justify-center items-center text-xl font-thin;
}

.icon-btn {
  @apply flex justify-center items-center;
  width: 42px;
  height: 60px;
  cursor: pointer;
}

.icon-btn:hover {
  @apply bg-gray-600;
}

.icon-msg {
  cursor: pointer;
}

.icon-msg:hover {
  @apply bg-gray-600;
}

.f-header .dropdown {
  height: 60px;
  cursor: pointer;
  @apply flex justify-center items-center mx-5;
}
</style>
